<template>
  <a-layout>
    <a-space>
      <a-input-search v-model="query['storageRoom.name']" :placeholder="$t('business.label.storageRoomName')" class="query" @pressEnter="refresh" @search="refresh"/>
      <a-select v-model="query['storageRoomType']" :options="storageRoomTypes" :placeholder="$t('business.label.storageRoomType')" allowClear class="query" @change="refresh"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>this.dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="no" sortable title="business.label.storageRoomNo" width="100"/>
      <vxe-column field="name" title="business.label.storageRoomName" width="120"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:storageRoomTypes}" field="storageRoomType" title="business.label.storageRoomType" width="80"/>
      <vxe-column :cell-render="{name:'FormatSelect',options:storageEnvironments}" field="storageEnvironment" title="business.label.storageEnvironment" width="80"/>
      <vxe-column field="floor" title="business.label.floor" width="60"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="automatic" title="business.label.automatic" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="allocable" title="business.label.allocable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="aggregate" title="business.label.aggregate" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="weighable" title="business.label.weighable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="checkable" title="business.label.checkable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="separable" title="business.label.separable" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="serialNumberManagement" title="business.label.serialNumberManagement" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="caseOnly" title="business.label.caseOnly" width="70"/>
      <vxe-column field="tag" title="business.label.tag" width="80"/>
      <vxe-column field="reservedLocations" title="business.label.reservedLocations" width="80"/>
      <vxe-column field="numberOfPickingOrder" title="business.label.numberOfPickingOrder" width="80"/>
      <vxe-column field="numberOfBarcode" title="business.label.numberOfBarcode" width="80"/>
      <vxe-column field="exchangeStorageRoom.name" title="business.label.exchangeStorageRoom"/>
      <vxe-column fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <storage-room-edit ref="storageRoomEdit" :storage-environments="storageEnvironments" :storage-room-types="storageRoomTypes" @success="refresh"/>
  </a-layout>
</template>
<script>
import Vue from 'vue'
import { findAll } from '@/api/Api'
import StorageRoomEdit from '@/views/basedata/storageroom_maintenance/StorageRoomEdit.vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'StorageRoomTable',
  components: {
    StorageRoomEdit
  },
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'storageRoomType': undefined,
        'storageRoom.name': ''
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.7725)// 表格竖向滚动条
    }
  },
  props: {
    storageRoomTypes: {
      type: Array,
      default: []
    },
    storageEnvironments: {
      type: Array,
      default: []
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('storageRoomFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    add() {
      this.$refs.storageRoomEdit.add()
    },
    edit(record) {
      this.$refs.storageRoomEdit.edit(record)
    },
    exportExcel() {
      this.$refs.table.openExport()
    },
    dblclick(row) {
      this.$emit('dblClick', row)
    },
    reset() {
      this.query['storageRoom.name'] = ''
      this.query['storageRoomType'] = undefined
      this.page = 1
      this.contentSize = 20
      this.fetch()
    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>